export enum MODE_ENV {
  PARTNER = "partner",
  ADMIN = "admin",
}
